import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import {
  FileSystemDirectoryEntry,
  FileSystemFileEntry,
  NgxFileDropComponent,
  NgxFileDropEntry,
  NgxFileDropModule,
} from 'ngx-file-drop';
import { Subscription } from 'rxjs';
import { ImageService } from '../../services/image.service';
import { SiaUsersService } from '../../services/users.service';

@Component({
  selector: 'sia-avatar',
  templateUrl: './sia-avatar.component.html',
  styleUrls: ['./sia-avatar.component.scss'],
  standalone: true,
  imports: [NgxFileDropModule],
})
export class SiaAvatarComponent implements OnInit, OnDestroy {
  private userService = inject(SiaUsersService);
  private imageService = inject(ImageService);

  @ViewChild(NgxFileDropComponent, { static: false })
  fileDrop?: NgxFileDropComponent;
  @Input() isDisabled: boolean = true;
  @Input() set userId(value: string) {
    this._userId = value;
    if (this._userId) {
      this.getAvatarUrl()
        .then((url: any) => {
          if (url) {
            this.url = url;
          } else {
            this.url = this._empty;
          }
        })
        .catch((e: any) => {});
    } else {
      this.url = this._empty;
    }
  }
  private _empty = '/assets/skeleton/empty-avatar.png';
  private _userId: string = '';
  get userId(): string {
    return this._userId;
  }
  private _value: any;
  set value(v) {
    this._value = v;
  }
  get value() {
    return this._value;
  }
  camera = '/assets/img/cameraPic.jpg';
  url: any;
  files: NgxFileDropEntry[] = [];
  private _subs: Subscription[] = [];

  ngOnDestroy() {
    this._empty = '';
    this._userId = '';
    this._value = null;
    this.camera = '';
    this.url = null;
    this.files = [];
    if (this.fileDrop?.fileSelector) {
      this.fileDrop?.fileSelector?.nativeElement.remove();
      (this.fileDrop as any).fileSelector = null;
    }
  }

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  ngOnInit() {
    this.url = this._empty;
  }

  uploadAvatarImage = (files: any) => {
    if (files.length === 0) {
      return;
    }

    if (!this.userId) {
      console.error('UserId non settato');
      return;
    }

    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('userId', this.userId);
    this.imageService.uploadAvatarImage(formData).then((res: any) => {
      if (res) {
        this.getAvatarUrl().then((url: any) => {
          this.url = url;
          // this.isPopupVisible = false;
        });
        this.userService.notifyAvatarChanged();
      } else {
        console.error("Errore in fase di salvataggio dell'avatar");
      }
    });
  };

  getAvatarUrl() {
    let r = this.userService.getUserAvatar(+this._userId);
    return r;
  }

  dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.uploadAvatarImage([file]);
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }
}
